type PropsType = {
  fill?: string;
};

const LongArrowIcon = ({ fill }: PropsType) => {
  return (
    <svg
      width="11"
      height="13"
      viewBox="0 0 11 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.75 5.75C0.335786 5.75 0 6.08579 0 6.5C0 6.91421 0.335786 7.25 0.75 7.25V5.75ZM10.7803 7.03033C11.0732 6.73744 11.0732 6.26256 10.7803 5.96967L6.00736 1.1967C5.71447 0.903806 5.23959 0.903806 4.9467 1.1967C4.65381 1.48959 4.65381 1.96447 4.9467 2.25736L9.18934 6.5L4.9467 10.7426C4.65381 11.0355 4.65381 11.5104 4.9467 11.8033C5.23959 12.0962 5.71447 12.0962 6.00736 11.8033L10.7803 7.03033ZM0.75 7.25H10.25V5.75H0.75V7.25Z"
        fill={fill ?? '#212427'}
      />
    </svg>
  );
};

export default LongArrowIcon;
